export const threeDropdown = {
	data() {
		return {
			isOpen: false
		}
	},
	methods: {
		switchOpen() {
			this.$root.$el.removeEventListener('click', this.switchOpen);
			setTimeout(() => {
				this.isOpen = !this.isOpen;
			}, 80)
		},
	},
	watch: {
		isOpen(val) {
			if (val)
				this.$root.$el.addEventListener('click', this.switchOpen);
		}
	},
};